export default class Child {
    constructor() {
        this._age = '';
    }
    get age() {
        return this._age;
    }
    get hasAge() {
        const int = parseInt(this.age, 10);
        return !Number.isNaN(int) && int >= 0 && int <= 17;
    }
    set age(age) {
        this._age = Math.max(0,age);
    }
}